import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    useEffect(() => {
        const credit = document.createComment(
            'Dev: Angel Zamora'
        );
        document.body.insertBefore(credit, document.body.firstChild);

        return () => {
            if (credit.parentNode) credit.parentNode.removeChild(credit);
        };
    }, []);

    return (
        <div className="container mx-auto px-6 py-24 max-w-4xl">
            <nav className="text-sm mb-12">
                <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
                <span className="mx-2 text-text-muted">/</span>
                <span className="text-dark-primary font-medium">Aviso de Privacidad</span>
            </nav>

            <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-8">
                Aviso de Privacidad
            </h1>

            <div className="prose prose-sm max-w-none text-text-muted space-y-6">
                <p className="text-sm">
                    <strong>JCB AZTECA S.A. de C.V.</strong> (en adelante "JCB Azteca"), con domicilio en 
                    Carr. Vhsa-Cardenas Ría. Anacleto Canabal Km. 0. 800, 86280 Villahermosa, Tab., 
                    es responsable del tratamiento de sus datos personales en términos de la Ley Federal 
                    de Protección de Datos Personales en Posesión de los Particulares (en adelante la "Ley").
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    1. Datos Personales que Recopilamos
                </h2>
                <p className="text-sm">
                    Para cumplir con las finalidades señaladas en el presente Aviso de Privacidad, 
                    JCB Azteca podrá recopilar los siguientes datos personales:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li>Nombre completo</li>
                    <li>Dirección de correo electrónico</li>
                    <li>Número de teléfono</li>
                    <li>Domicilio</li>
                    <li>Información de contacto laboral</li>
                    <li>Datos de la empresa o entidad a la que representa</li>
                    <li>Información sobre su vehículo o maquinaria de interés</li>
                </ul>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    2. Finalidades del Tratamiento de Datos
                </h2>
                <p className="text-sm">
                    Los datos personales que recopilamos serán utilizados para las siguientes finalidades:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li>Proporcionar información y cotizaciones sobre nuestros productos y servicios</li>
                    <li>Atender solicitudes de información, quejas y aclaraciones</li>
                    <li>Gestionar la relación comercial con nuestros clientes y proveedores</li>
                    <li>Enviar comunicaciones promocionales y publicidad sobre nuestros productos y servicios</li>
                    <li>Realizar encuestas de satisfacción y calidad</li>
                    <li>Cumplir con obligaciones legales y regulatorias</li>
                </ul>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    3. Transferencia de Datos Personales
                </h2>
                <p className="text-sm">
                    JCB Azteca podrá transferir sus datos personales a terceros proveedores de servicios 
                    que nos auxilien en la prestación de nuestros servicios, como empresas de mensajería, 
                    servicios de marketing, y proveedores de tecnología. En todos los casos, dichos terceros 
                    se obligan a tratar sus datos personales conforme a este Aviso de Privacidad y la Ley.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    4. Derechos ARCO
                </h2>
                <p className="text-sm">
                    Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos 
                    y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la 
                    corrección de su información personal en caso de que esté desactualizada, sea inexacta o 
                    incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando 
                    considere que la misma no está siendo utilizada conforme a los principios, deberes y 
                    obligaciones previstas en la Ley (Cancelación); así como oponerse al uso de sus datos 
                    personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.
                </p>
                <p className="text-sm">
                    Para ejercer sus derechos ARCO, usted deberá presentar una solicitud por escrito dirigida a 
                    nuestro Departamento de Privacidad, a través del correo electrónico: 
                    <a href="mailto:privacidad@jcbazteca.com" className="text-jcb-yellow hover:text-dark-primary transition-colors">
                        privacidad@jcbazteca.com
                    </a>
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    5. Uso de Cookies
                </h2>
                <p className="text-sm">
                    Nuestro sitio web utiliza cookies y tecnologías similares para mejorar su experiencia de 
                    navegación, analizar el tráfico y personalizar contenido. Puede configurar su navegador 
                    para rechazar cookies, sin embargo, esto podría afectar la funcionalidad del sitio.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    6. Modificaciones al Aviso de Privacidad
                </h2>
                <p className="text-sm">
                    JCB Azteca se reserva el derecho de modificar, actualizar o cambiar el presente Aviso de 
                    Privacidad en cualquier momento. Dichos cambios serán publicados en nuestro sitio web 
                    <Link to="/privacy-policy" className="text-jcb-yellow hover:text-dark-primary transition-colors">
                        www.jcbazteca.com
                    </Link>
                    y entrarán en vigor a partir de su publicación.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    7. Contacto
                </h2>
                <p className="text-sm">
                    Si tiene alguna pregunta sobre este Aviso de Privacidad o desea ejercer sus derechos ARCO, 
                    puede contactarnos a través de:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li><strong>Correo electrónico:</strong> privacidad@jcbazteca.com</li>
                    <li><strong>Teléfono:</strong> +52 (993) 478 4100</li>
                    <li><strong>Domicilio:</strong> Carr. Vhsa-Cardenas Ría. Anacleto Canabal Km. 0. 800, 86280 Villahermosa, Tab.</li>
                </ul>

                <p className="text-sm text-text-subtle mt-8">
                    <strong>Última actualización:</strong> Septiembre de 2026
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;